import { render, staticRenderFns } from "./GoodsPage.vue?vue&type=template&id=353955c0&scoped=true&"
import script from "./GoodsPage.vue?vue&type=script&lang=js&"
export * from "./GoodsPage.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPage.vue?vue&type=style&index=0&id=353955c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353955c0",
  null
  
)

export default component.exports